import React, { useContext, useEffect, useState } from "react";
import { Backdrop } from "@mui/material";
import moment from "moment";

import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/GreyEditIcon.svg";

import ALoader from "views/pages/manage/common/a-loader";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";

import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint, pages } from "../../../../common/constant";
import styles from "./logsTableStyle.module.css";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
const AInputStyle = { height: "40px" };

export const findModule = (moduleName, moduleList = []) => {
  return moduleList.find((item) => item.disabledModules === moduleName);
};
const StockEnableDisable = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [latestStatus, setLatestStatus] = useState({
    STOCK_ISSUANCE: null,
    STOCK_RETURN: null,
    BRANCH_CONSUMPTION: null,
    BRANCH_CONSUMPTION_RETURN: null,
  });
  const [rowCount, setRowCount] = useState(0);
  const [currentPageNumber, setPageNumber] = useState(0);
  const userPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["stockEnableDisable"]["id"]
    ) || [];

  useEffect(() => {
    fetchLogs();
  }, [currentPageNumber]);

  const fetchLogs = async () => {
    setIsLoading(true);
    const res = await fetchAllPromisedData(
      `${endpoint?.stockEnable?.getLogs}?offset=${currentPageNumber}&pageSize=50`,
      true
    );
    if (res?.code === 200) {
      setRows(res.data.stockIssuanceConfigurationAudList);
      setRowCount(res.data.totalRecords);

      const latestStatus = res.data.stockIssuanceConfigurationList;
      setLatestStatus({
        STOCK_ISSUANCE: findModule("STOCK_ISSUANCE", latestStatus),
        STOCK_RETURN: findModule("STOCK_RETURN", latestStatus),
        BRANCH_CONSUMPTION: findModule("STOCK_RETURN", latestStatus),
        BRANCH_CONSUMPTION_RETURN: findModule(
          "BRANCH_CONSUMPTION_RETURN",
          latestStatus
        ),
        ISSUANCE_CONTROL: findModule("ISSUANCE_CONTROL", latestStatus),
        RETURN_CONTROL: findModule("RETURN_CONTROL", latestStatus),
      });
    } else {
      setRows([]);
    }

    setIsLoading(false);
  };

  const nextButtonHandler = (pageNum) => {
    setPageNumber(pageNum);
  };

  const statusDropdown = [
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "Inactive",
      value: "INACTIVE",
    },
  ];

  const MASTER_TYPE = [
    {
      label: "Stock Issuance",
      value: "STOCK_ISSUANCE",
    },
    {
      label: "Stock Return",
      value: "STOCK_RETURN",
    },
    {
      label: "Branch Consumption",
      value: "BRANCH_CONSUMPTION",
    },
    {
      label: "Branch Consumption Return ",
      value: "BRANCH_CONSUMPTION_RETURN",
    },
    {
      label: "Issuance control",
      value: "ISSUANCE_CONTROL",
    },
    {
      label: "Return control",
      value: "RETURN_CONTROL",
    },
  ];

  const COLUMNS = [
    new AGridColDef("disabledModules", "Master Type", false)
      .setMinWidth(290)
      .editable(false)
      .renderCellComponent((params) => <div>{params?.value || "-"}</div>),

    new AGridColDef("fromDate", "Start date or Days", false)
      .editable(false)
      .renderCellComponent((params) => (
        <div>
          {isEnableDayForm(params?.row.disabledModules)
            ? params?.row.daysBeforeStart
            : moment(params?.value).format("DD MMM YYYY")}{" "}
        </div>
      )),

    new AGridColDef("toDate", "End date or Days", false)

      .editable(false)
      .renderCellComponent((params) => (
        <div>
          {isEnableDayForm(params?.row.disabledModules)
            ? params?.row.daysBeforeEnd
            : moment(params?.value).format("DD MMM YYYY")}
        </div>
      )),

    new AGridColDef("prevStatus", "Previous State", false)

      .editable(false)
      .renderCellComponent((params) => (
        <div style={{ textTransform: "capitalize" }}>
          {params?.value?.toLowerCase() || "-"}
        </div>
      )),

    new AGridColDef("status", "Current State", false).renderCellComponent(
      (params) => (
        <div style={{ textTransform: "capitalize" }}>
          {params?.value.toLowerCase() || "-"}
        </div>
      )
    ),

    new AGridColDef("updatedOn", "Updated On", false)

      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) => (
        <div>{moment(params?.value).format("DD MMM YYYY")}</div>
      )),

    new AGridColDef("updatedBy", "Updated By", false).renderCellComponent(
      (params) => <div>{params?.value || "-"}</div>
    ),
  ];

  const handleBackClick = () => {
    window.history.go(-1);
  };

  const filterFormHandler = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const handleEditStatus = (formValues = {}) => {
    const {
      disabledModules,
      status,
      fromDate,
      toDate,
      restrictedBU,
      daysBeforeStart,
      daysBeforeEnd,
    } = formValues;
    setIsEdit(true);
    setForm({
      moduleName: {
        value: disabledModules,
        label: MASTER_TYPE.find((item) => item.value === disabledModules).label,
      },
      status: {
        value: status,
        label: statusDropdown.find((item) => item.value === status).label,
      },
      fromDate: moment(fromDate) || moment(),
      toDate: moment(toDate).endOf("day") || moment().endOf("day"),
      restrictedBU,
      daysBeforeStart,
      daysBeforeEnd,
    });
  };

  const handleUpdateStatus = async () => {
    const payload = {
      moduleName: form.moduleName.value,
      status: form.status.value,
      fromDate: moment(form.fromDate).format("YYYY-MM-DD"),
      toDate: moment(form.toDate).format("YYYY-MM-DD"),
      restrictedBu: "ALL",
      daysBeforeStart: form?.daysBeforeStart,
      daysBeforeEnd: form?.daysBeforeEnd,
    };

    setIsLoading(true);

    const response = await fetchAllPostPromisedData(
      `${endpoint.stockEnable.updateStatus}`,
      payload,
      "post"
    );

    if (response?.code === 200) {
      setIsEdit(false);
      setForm({});
      if (currentPageNumber) setPageNumber(0);
      else fetchLogs();
    }

    setIsLoading(false);
  };

  const isEnableDayForm = (moduleName) => {
    return ["ISSUANCE_CONTROL", "RETURN_CONTROL"].includes(moduleName);
  };

  return (
    <div className="px-4">
      <div className="d-flex align-items-center text-dark">
        <IconButtonWrapper onClick={handleBackClick}>
          <BackIcon />
        </IconButtonWrapper>
        <h2 className="ml-2 mb-0">Stock Enablement</h2>
      </div>

      <div className={`${styles.card}`}>
        <h2 className={styles.heading}>Current Master Status</h2>

        <div className={styles.grid}>
          {MASTER_TYPE.map(({ label, value }) => {
            const { updatedOn = "", status = "active" } =
              latestStatus[value] ?? {};

            return (
              <div key={value} className={`${styles.cardDetail} mt-2`}>
                <div className="d-flex flex-column">
                  <h3 className={styles.cardHeading}>{label}</h3>
                  <small
                    style={{
                      visibility: !updatedOn ? "hidden" : "visible",
                    }}
                    className={styles.lastUpdatedDate}
                  >
                    Last updated on {moment(updatedOn).format("DD MMM YYYY")}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  <span
                    className={styles.statusBadge}
                    style={{
                      color:
                        status.toLowerCase() === "inactive"
                          ? "#B32306"
                          : "#0B442D",

                      background:
                        status.toLowerCase() === "inactive"
                          ? "#F9D9D7"
                          : "#BBE2CE",
                    }}
                  >
                    {status?.toLowerCase()}
                  </span>
                  <span
                    style={{ visibility: isEdit ? "hidden" : "visible" }}
                    className={styles.editIcon}
                  >
                    {(userPermissions?.includes("C") ||
                      userPermissions?.includes("U")) && (
                      <IconButtonWrapper
                        onClick={() => handleEditStatus(latestStatus[value])}
                        className={styles.editBtn}
                      >
                        <EditIcon width="12px" height="12px" />
                      </IconButtonWrapper>
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ display: isEdit ? "block" : "none" }}>
          <h2 className={`${styles.tableHeading} mt-5`}>
            Change Status for {form?.moduleName?.label?.toLowerCase()}
          </h2>

          <div className={styles.form}>
            <AAutoComplete
              label="Master Type"
              placeholder="Select"
              items={MASTER_TYPE}
              currentValue={form.moduleName}
              handleChange={(value) => {
                filterFormHandler("moduleName", value);
              }}
              isMulti={false}
              height="40px"
            />

            {isEnableDayForm(form.moduleName?.value) ? (
              <div className={styles["form_input"]}>
                <AInput
                  value={form.daysBeforeStart}
                  label="No. of days before course start date"
                  placeholder="Enter the value"
                  handler={(value) =>
                    filterFormHandler("daysBeforeStart", value)
                  }
                  maxLength={50}
                  style={AInputStyle}
                />
              </div>
            ) : (
              <div className="mt-auto">
                <small className="text-xs">Start Date</small>
                <CustomDatePicker
                  placeHolder="Start Date"
                  value={form.fromDate}
                  handler={(index, date, keyName) => {
                    filterFormHandler("fromDate", date);

                    //   update end-date
                    filterFormHandler("toDate", moment(date)?.add(1, "month"));
                  }}
                  minDate={moment.min([
                    moment(form.fromDate),
                    moment().subtract(1, "month"),
                  ])}
                  maxDate={moment()}
                />
              </div>
            )}
            {isEnableDayForm(form.moduleName?.value) ? (
              <div className={styles["form_input"]}>
                <AInput
                  label="No. of days after course end date"
                  value={form.daysBeforeEnd}
                  placeholder="Enter the value"
                  handler={(value) => filterFormHandler("daysBeforeEnd", value)}
                  maxLength={50}
                  style={AInputStyle}
                />
              </div>
            ) : (
              <div className="mt-auto">
                <small className="text-xs">End Date</small>
                <CustomDatePicker
                  placeHolder="End Date"
                  value={form.toDate}
                  handler={(index, date, keyName) => {
                    filterFormHandler("toDate", moment(date).endOf("day"));
                  }}
                  minDate={moment(form.fromDate)}
                  maxDate={moment(form.fromDate)?.add(1, "month")}
                />
              </div>
            )}

            <AAutoComplete
              label="New Status"
              placeholder="Select"
              items={statusDropdown}
              currentValue={form.status}
              handleChange={(value) => {
                filterFormHandler("status", value);
              }}
              isMulti={false}
              height="40px"
            />

            <AButton
              variant="outline_danger"
              className="h-full no-ml-btn mt-auto"
              onClick={() => {
                setIsEdit(false);
                setForm({});
              }}
            >
              Cancel
            </AButton>

            <AButton
              variant="primary_filled"
              className="w-full no-ml-btn mt-auto"
              onClick={handleUpdateStatus}
              //   disabled={isDisabled}
            >
              Change status
            </AButton>
          </div>
        </div>
      </div>

      <div className={`${styles.card}`}>
        <h3 className={styles.tableHeading}>Change Logs</h3>
        <ADataGrid
          removeWrapperContainer
          rows={rows || []}
          columns={COLUMNS}
          rowId={(row) => row.rev}
          rowHeight={50}
          loading={false}
          rowCount={rowCount}
          nextButtonHandler={nextButtonHandler}
          currentPage={currentPageNumber}
          sx={{
            ".MuiDataGrid-main": {
              height: "500px",
            },
          }}
        />
      </div>

      {isLoading && (
        <Backdrop
          sx={() => ({
            color: "#fff",
          })}
          open={isLoading}
        >
          <ALoader />
        </Backdrop>
      )}
    </div>
  );
};

export default StockEnableDisable;
